import Nullstack from 'nullstack';
export default function IconTextWrap({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-text-wrap",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "6",
    x2: "20",
    y2: "6"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "18",
    x2: "9",
    y2: "18"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2"
  }), " ");
}